import { hoistStatics, shouldUpdate } from 'recompose';
import { isEqual } from 'lodash';

export default hoistStatics(shouldUpdate(
  (props, nextProps) => !isEqual(props, nextProps),
));
